const events = ['chat_started', 'audio_started', 'widget_opened']

function setReadyForInstance(sdkInstance) {
  if (sdkInstance instanceof Sdk) {
    const event = new Event('trueengage:sdk_initialized')
    document.dispatchEvent(event)
  } else {
    throw new Error('Invalid SDK instance')
  }
}

class Sdk {
  constructor(visitorId, widgetContainer) {
    this.data = {
      visitorId: visitorId,
      audioRemoteName: 'TrueEngage webrtc ' + window.location.href,
      videoRemoteName: 'Video',
      customAttributes: {},
    }
    this.widgetContainer = widgetContainer
  }

  addCustomAttribute(key, value) {
    if (key && typeof key === 'string') {
      this.data.customAttributes[key] = value
    } else {
      console.error('Key must be a non-empty string')
    }
  }

  on(eventName, callback) {
    if (!events.includes(eventName)) throw new Error(`[TrueEngage] event ${eventName} does not exist`)

    if (eventName === 'chat_started') {
      document.addEventListener(`trueengage:chat_started`, (e) => {
        let data = e.detail
        callback(data.message_id, data.visitor_id)
      })
    }

    if (eventName === 'audio_started') {
      document.addEventListener(`trueengage:communication_started`, (e) => {
        let data = e.detail
        if (data.communication_channel === 'audio') {
          callback()
        }
      })
    }

    if (eventName === 'widget_opened') {
      document.addEventListener(`trueengage:widget_opened`, () => {
        callback()
      })
    }

    return true
  }

  get(propertyName) {
    if (!Object.keys(this.data).includes(propertyName)) throw new Error(`[TrueEngage] property ${propertyName} does not exist`)

    return this.data[propertyName]
  }

  getCustomAttribute(key) {
    if (key && typeof key === 'string') {
      return this.data.customAttributes[key] || null
    } else {
      console.error('Key must be a non-empty string')
      return null
    }
  }
}

export { Sdk, setReadyForInstance }
